import type { JSONContent } from '@tiptap/react';

import type { AcademicYear } from '@/enums/users';
import type { StudentProfileModelType } from '@/models/users';
import type { OperationInfo } from '@/types/shared';

export enum StudentStatus {
  NOT_FOUND = -1,
  BANNED = 0,
  ONLY_EMAIL = 1,
  REGISTERED = 2,
  ACTIVE = 3,
}

export type ProfileUpdateResponse = {
  updateProfile: StudentProfileModelType & OperationInfo;
};

type UserInput = {
  firstName: string;
  lastName: string;
  email: string;
  photo: File | string | null;
};

export type CountryInputType = {
  id: string;
};

export type UniversityInputType = {
  id?: string;
  country: CountryInputType;
  shortName?: string;
};

export type StudentUniversityInputType = {
  id?: string;
  university: UniversityInputType;
  courseOfStudy: string;
  academicYear: AcademicYear;
  graduationYear: number | null;
};

export type StudentPortfolioRecordInputType = {
  id: string;
  projectTitle: string;
  year: number;
  company: string;
  link: string;
  description: JSONContent;
};

export type StudentProfileInputType = {
  tz: string;
  about: JSONContent;
  portfolioLink: string;
  ICPCParticipant: boolean;
  ICPCContest?: any;
  user: UserInput;
  universities: StudentUniversityInputType[];
  portfolioRecords: StudentPortfolioRecordInputType[];
};
